import {
  RuleCardDropdown,
  type RuleCardDropdownProps,
} from '@carboncopyco/editor-ui';
import { PositionedToggle } from '@carboncopyco/ui';
import { useMemo } from 'react';

export const SpotEditsActionDropdown = ({
  onDelete,
  setGlobalRule,
  isGlobalRule,
}: {
  isGlobalRule?: boolean;
  onDelete: () => void;
  setGlobalRule: (isGlobal: boolean) => void;
}) => {
  const dropdownItems = useMemo(
    () =>
      [
        {
          type: 'makeGlobalRule',
          iconRight: (
            <PositionedToggle
              checked={isGlobalRule}
              onChange={() => {
                return;
              }}
            />
          ),
          onClick: () => {
            setGlobalRule(!isGlobalRule);
          },
        },
        {
          type: 'delete',
          onClick: onDelete,
        },
      ] as RuleCardDropdownProps['items'],
    [onDelete, setGlobalRule, isGlobalRule]
  );

  return (
    <RuleCardDropdown
      items={dropdownItems}
      zIndex={200}
    />
  );
};
